// Fetch-instrumentation exclusion list for the browser SDK.
//
// The OTLP proxy endpoint MUST be in this list: FetchInstrumentation spans
// every fetch, and OTLP exports are themselves fetches. Without the
// exclusion, each telemetry POST creates a span, which gets exported in the
// next batch, which creates another span — a feedback loop that only the
// AttentionOnlySpanProcessor's latency filter (sometimes) breaks.

export function buildFetchIgnoreUrls(
  otlpEndpoint: string,
): Array<string | RegExp> {
  // RegExp.escape is ES2025 — guard for older mobile browsers where a throw
  // here would kill the whole observability init. The unescaped fallback is
  // safe degradation: the real endpoint ("/api/otlp") has no metacharacters.
  const escaped =
    typeof RegExp.escape === "function"
      ? RegExp.escape(otlpEndpoint)
      : otlpEndpoint;
  return [/\/api\/health/, /signoz\.atriam\.ai/, new RegExp(escaped)];
}
